import { Instagram, ExternalLink } from "lucide-react";
import { useT } from "@/lib/i18n";

const images = [
  "https://images.unsplash.com/photo-1592656094267-764a45160876?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiZWFjaCUyMHZvbGxleWJhbGwlMjBhY3Rpb258ZW58MHx8fHwxNzc4NzUzNjMwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1521138054413-5a47d349b7af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxiZWFjaCUyMHZvbGxleWJhbGwlMjBhY3Rpb258ZW58MHx8fHwxNzc4NzUzNjMwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxzdW5zZXQlMjBiZWFjaCUyMHZvbGxleWJhbGx8ZW58MHx8fHwxNzc4NzUzNjMwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1592656094267-764a45160876?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiZWFjaCUyMHZvbGxleWJhbGwlMjBhY3Rpb258ZW58MHx8fHwxNzc4NzUzNjMwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1521138054413-5a47d349b7af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxiZWFjaCUyMHZvbGxleWJhbGwlMjBhY3Rpb258ZW58MHx8fHwxNzc4NzUzNjMwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxzdW5zZXQlMjBiZWFjaCUyMHZvbGxleWJhbGx8ZW58MHx8fHwxNzc4NzUzNjMwfDA&ixlib=rb-4.1.0&q=85",
];

export default function InstagramSection() {
  const { t } = useT();
  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="relative py-20 md:py-32 bg-sand/40"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <a
              href="https://www.instagram.com/the_sand_lab"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-handle-link"
              className="inline-block text-xs font-semibold tracking-widest uppercase text-sunset mb-3 hover:underline"
            >
              {t("ig_label")}
            </a>
            <h2 className="font-heading font-black text-4xl sm:text-5xl text-slate-900 leading-tight">
              {t("ig_title_a")}
              <br />
              <span className="text-ocean">{t("ig_title_b")}</span>
            </h2>
          </div>
          <a
            href="https://www.instagram.com/the_sand_lab"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="inline-flex items-center gap-2 self-start px-6 py-3 rounded-full bg-slate-900 text-white font-semibold hover:bg-slate-800 transition-colors"
          >
            <Instagram className="h-4 w-4" />
            {t("ig_follow")}
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
          {images.map((src, i) => (
            <a
              key={i}
              href="https://www.instagram.com/the_sand_lab"
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="relative group block aspect-square rounded-3xl overflow-hidden bg-slate-200"
            >
              <img
                src={src}
                alt={`Instagram tile ${i + 1}`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ocean/70 via-ocean/0 to-ocean/0 opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-start p-4">
                <Instagram className="h-5 w-5 text-white" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
